import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// マイナンバー申請確認
export const i_0005_update = (params, userCd) => {
  return http.requestPost(apiUrl.apiUrl_StaffApplyConfirmLog + '?userCd=' + userCd, [params]);
}



// WEBPACK FOOTER //
// ./src/module/api/i_0005.js